import PropTypes from "prop-types";
import {
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
  Box,
  FormControl,
  MenuItem,
  Select,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";

const actionButtonSx = {
  contained: {
    backgroundColor: "#17a2b8",
    color: "#fff",
    textTransform: "none",
    "&:hover": { backgroundColor: "#138496" },
  },
  outlined: {
    color: "#6c757d",
    borderColor: "#dee2e6",
    textTransform: "none",
    "&:hover": { borderColor: "#ced4da" },
  },
};

export default function DeleteUserDialogBody({
  modalTitle,
  needsReassign,
  lblReassign,
  lblSelectAnnotator,
  lblConfirmDel,
  btnProceed,
  btnDiscard,
  annotatorList,
  selectedValue,
  setSelectedValue,
  loading,
  onProceed,
  onConfirm,
  onCancel,
}) {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  return (
    <MDBox p={3}>
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          p: 0,
          mb: 2,
        }}
      >
        <MDTypography variant="h6">{modalTitle}</MDTypography>
        <IconButton onClick={onCancel} aria-label="close" disabled={loading}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      {needsReassign ? (
        <DialogContent id="proceed_dialog" sx={{ backgroundColor: "#f8f9fa", p: 2 }}>
          <DialogContent sx={{ p: 0, mb: 1 }}>
            <MDTypography py={2} sx={{ fontSize: "16px", color: "black" }}>
              {lblReassign}
            </MDTypography>
            <Box width={300}>
              <FormControl fullWidth>
                <Select
                  value={selectedValue}
                  onChange={(e) => setSelectedValue(e.target.value)}
                  displayEmpty
                  fullWidth
                  disabled={loading}
                  sx={{ height: 40, px: 1 }}
                  onOpen={() => setIsDropdownOpen(true)}
                  onClose={() => setIsDropdownOpen(false)}
                  IconComponent={() => (
                    <FontAwesomeIcon icon={isDropdownOpen ? faChevronUp : faChevronDown} />
                  )}
                >
                  <MenuItem value="">
                    <em>{lblSelectAnnotator}</em>
                  </MenuItem>
                  {annotatorList.map((option) => (
                    <MenuItem key={option.id} value={option.id}>
                      {(option.first_name || "") + " " + (option.last_name || "")}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={onProceed}
              variant="contained"
              disabled={loading}
              sx={actionButtonSx.contained}
            >
              {btnProceed}
            </Button>
            <Button
              onClick={onCancel}
              variant="outlined"
              disabled={loading}
              sx={actionButtonSx.outlined}
            >
              {btnDiscard}
            </Button>
          </DialogActions>
        </DialogContent>
      ) : (
        <DialogContent id="delete_dialog" sx={{ backgroundColor: "#f8f9fa", p: 2 }}>
          <DialogContent sx={{ p: 0, mb: 2 }}>
            <MDTypography sx={{ fontSize: "16px" }}>{lblConfirmDel}</MDTypography>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={onConfirm}
              variant="contained"
              disabled={loading}
              sx={actionButtonSx.contained}
            >
              {btnProceed}
            </Button>
            <Button
              onClick={onCancel}
              variant="outlined"
              disabled={loading}
              sx={actionButtonSx.outlined}
            >
              {btnDiscard}
            </Button>
          </DialogActions>
        </DialogContent>
      )}
    </MDBox>
  );
}

DeleteUserDialogBody.propTypes = {
  modalTitle: PropTypes.string.isRequired,
  needsReassign: PropTypes.bool.isRequired,
  lblReassign: PropTypes.string.isRequired,
  lblSelectAnnotator: PropTypes.string.isRequired,
  lblConfirmDel: PropTypes.string.isRequired,
  btnProceed: PropTypes.string.isRequired,
  btnDiscard: PropTypes.string.isRequired,
  annotatorList: PropTypes.arrayOf(PropTypes.object).isRequired,
  selectedValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  setSelectedValue: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  onProceed: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};
